var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subject"},[(_vm.name === "math")?_c('img',{staticClass:"subject__image",attrs:{"src":require("@/assets/practices/global/subject/math.svg"),"alt":"subject_math"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }